import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Card, Col, DatePicker, Form, Table, Input, InputNumber, Popconfirm, Row, Select, Space, message } from 'antd';
import { useGetAreaQuery, useGetEndPortQuery, useGetStartPortQuery } from '@/store/apiSlice';
import { createJsonOptions } from '@/scripts/utils';
import { FORM_RULE_REQUIRED } from '@/scripts/config';
import dayjs from 'dayjs';
import _ from 'lodash';
import { SocketsContext } from '@/App';
import { io } from 'socket.io-client';
import { Five } from '@icon-park/react';
import ajax from '@/scripts/ajax';

const defaultValue = {
    account_num: 1,
    account_end: 50,
    cargo_weight: 15000,
    cargo_details: 'Fabrics, textiles',
    quantity: 1,
    export_service_mode: 'CY',
    import_service_mode: 'CY',
    free_time_days: 0,
    origin_location: 'NingBo,104T898SJZ6GU',
    container_details: '40 Dry High',
};

const serviceModeOptions = [
    { label: 'CY', value: 'CY' },
    { label: 'SD', value: 'SD' },
];

export default function BookingForm(props) {
    const [form] = Form.useForm();
    const { data: startPortOptions } = useGetStartPortQuery(0);
    const { data: endPortOptions } = useGetEndPortQuery(0);
    const { data: areaOptions } = useGetAreaQuery();
    const [dataSource, setState] = useState([]);

    useEffect(() => {}, []);

    // 开始订舱
    const handleSubmit = () => {
        form.validateFields()
            .then((formValue) => {
                const { earliest_departure_date, ...rest } = formValue;
                const value = {
                    earliest_departure_date: dayjs(formValue.earliest_departure_date).format('YYYY-MM-DD 00:00:00'),
                    ...rest,
                };
                ajax.post('/show/detail', value)
                    .then((res) => {
                        setState(res);
                        message.success('请求成功');
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    // 加载订舱
    const handleLoading = () => {
        form.validateFields()
            .then((formValue) => {
                const { earliest_departure_date, ...rest } = formValue;
                const value = {
                    earliest_departure_date: dayjs(formValue.earliest_departure_date).format('YYYY-MM-DD 00:00:00'),
                    ...rest,
                };
                ajax.post('/show/detail2', value)
                    .then((res) => {
                        setState(res);
                        message.success('请求成功');
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const columns = [
        {
            title: 'date',
            dataIndex: 'date',
            align: 'center',
            width: 600,
        },
        {
            title: 'cid',
            dataIndex: 'cid_price',
            align: 'center',
            width: 600,
        },
        {
            title: 'vessel',
            dataIndex: 'vessel',
            align: 'center',
            width: 600,
        },
        {
            title: 'routeStatus',
            dataIndex: 'routeStatus',
            align: 'center',
            width: 600,
        },
    ];

    return (
        <div>
            <Form form={form} initialValues={defaultValue}>
                <Card style={{ minWidth: 1150 }}>
                    <Row gutter={16}>
                        <Col span={6} style={{ display: 'flex', alignItems: 'flex-start' }}>
                            <Form.Item label="账号" name="account_num" required rules={[FORM_RULE_REQUIRED]}>
                                <InputNumber min={1} precision={0} />
                            </Form.Item>
                            <Form.Item noStyle name="account_end" required rules={[FORM_RULE_REQUIRED]}>
                                <InputNumber min={1} precision={0} style={{ marginLeft: 8 }} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="重量" name="cargo_weight" required rules={[FORM_RULE_REQUIRED]}>
                                <InputNumber style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="品名" name="cargo_details" required rules={[FORM_RULE_REQUIRED]}>
                                <Input disabled></Input>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="启始" name="origin_location" required rules={[FORM_RULE_REQUIRED]}>
                                <Select options={createJsonOptions(startPortOptions)} showSearch allowClear></Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="订单" name="quantity" required rules={[FORM_RULE_REQUIRED]}>
                                <InputNumber style={{ width: '100%' }}></InputNumber>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                <Form.Item label="模式" name="export_service_mode" required rules={[FORM_RULE_REQUIRED]}>
                                    <Select options={serviceModeOptions}></Select>
                                </Form.Item>
                                <Form.Item noStyle name="import_service_mode" required rules={[FORM_RULE_REQUIRED]}>
                                    <Select options={serviceModeOptions} style={{ marginLeft: 8 }}></Select>
                                </Form.Item>
                            </div>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="日期" name="earliest_departure_date" required rules={[FORM_RULE_REQUIRED]}>
                                <DatePicker />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="区域" name="area">
                                <Select options={createJsonOptions(areaOptions)} showSearch allowClear></Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}></Col>
                        <Col span={6}>
                            <Form.Item label="免用" name="free_time_days" required rules={[FORM_RULE_REQUIRED]}>
                                <Select
                                    options={createJsonOptions(
                                        Array(22)
                                            .fill(0)
                                            .map((_, index) => index),
                                    )}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="箱型" name="container_details" required rules={[FORM_RULE_REQUIRED]}>
                                <Select
                                    options={createJsonOptions(['20 Dry Standard', '40 Dry High', '40 Reefer High', '45 Dry High'])}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="目的" name="destination_location" required rules={[FORM_RULE_REQUIRED]}>
                                <Select options={createJsonOptions(endPortOptions)} showSearch allowClear></Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={handleLoading} style={{ marginRight: '15px' }} type="primary">
                            加载订舱
                        </Button>

                        <Button onClick={handleSubmit} type="primary">
                            开始订舱
                        </Button>
                    </div>
                </Card>
                <Table rowKey={(record) => record.id} bordered pagination={false} dataSource={dataSource} columns={columns} />
            </Form>
        </div>
    );
}
